import { Injectable } from "@angular/core";
import { catchError } from "rxjs/operators";
import { EMPTY, Observable, of } from "rxjs";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { LaunchpadAsset } from "@modules/launchpad/domain/entities/launchpad-asset";
import { LaunchpadNewsletterSub } from "@modules/launchpad/domain/entities/launchpad-newsletter-sub";
import { ErrorClass } from "bp-common-models-lib";
import { ToastrService } from "ngx-toastr";

@Injectable({
	providedIn: "root"
})
export class LaunchpadRemote {
	constructor(
		private readonly apiCallService: ApicallService,
		private readonly toastr: ToastrService
	) {}

	public getLaunchpadAssets$(): Observable<LaunchpadAsset[]> {
		return this.apiCallService.get("launchpad/assets");
	}

	public getNewsletterSub$(): Observable<LaunchpadNewsletterSub> {
		const option = new ApicallOption();
		option.raw = true;

		return this.apiCallService.get("communications/spotlight", option).pipe(
			catchError((e) =>
				// to not block page load, we assume 'false' for now
				of({
					is_subscribed: false
				})
			)
		);
	}

	public setNewsletterSub$(): Observable<void> {
		return this.apiCallService.post("communications/spotlight", new ApicallOption()).pipe(
			catchError((e) => {
				this.handleError(e);
				return EMPTY;
			})
		);
	}

	public unsetNewsletterSub$(): Observable<void> {
		return this.apiCallService.deleteRequest("communications/spotlight", new ApicallOption()).pipe(
			catchError((e) => {
				this.handleError(e);
				return EMPTY;
			})
		);
	}

	public setAssetSub$(id: number): Observable<void> {
		return this.apiCallService.post(`launchpad/assets/${id}/subscription`, new ApicallOption()).pipe(
			catchError((e) => {
				this.handleError(e);
				return EMPTY;
			})
		);
	}

	public unsetAssetSub$(id: number): Observable<void> {
		return this.apiCallService.deleteRequest(`launchpad/assets/${id}/subscription`, new ApicallOption()).pipe(
			catchError((e) => {
				this.handleError(e);
				return EMPTY;
			})
		);
	}

	private handleError(e: ErrorClass): void {
		const errors = e?.responseErrors;

		if (errors) {
			errors.forEach((e) => {
				// onyl display the error if we have the "title" property
				e.title && this.toastr.error(e.title, "");
			});
		}
	}
}
